// or get from process.env.REACT_APP_{var} to handle PROD and DEV environments
export const APP_VERSION = '2.0.0';
export const API_BASE_URL = '/api';
export const ENABLE_REDUX_LOGGER = false;
export const LANDING_URL = process.env.REACT_APP_LANDING_URL || 'https://tubesoft.cl';
